import React from "react";
import { Box, Container, Typography } from "@mui/material";
import AvgStudyAdherence from "./AvgStudyAdherence";
import StudyAdherenceDistribution from "./StudyAdherenceDistribution";
import AlertsAnalytics from "./AlertsAnalytics";
import StudiesMetricsTable from "./StudiesMetricsTable";

const AdherenceMonitor: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{ fontWeight: 600 }}
        >
          Study Adherence Monitor
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          Monitor adherence and engagement patterns across all studies
        </Typography>
      </Box>

      {/* Average Study Adherence Component */}
      <AvgStudyAdherence />

      {/* Study Adherence Distribution Component */}
      <StudyAdherenceDistribution />

      {/* Alerts Analytics Component */}
      <AlertsAnalytics />

      {/* Studies Metrics Table Component */}
      <StudiesMetricsTable />
    </Container>
  );
};

export default AdherenceMonitor;
